import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { TicketRequestForm } from '@/components/forms/TicketRequestForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function AllTicketsCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/ticket-management/all-tickets')
  }

  const handleCancel = () => {
    navigate('/ticket-management/all-tickets')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Ticket</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new ticket request
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex="1" minH={0}>
              <TicketRequestForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
